import styled from "styled-components";

export const Content = styled("p")`
  margin-top: 1.5rem;
`;

export const Container = styled("div")`
  position: relative;
  max-width: 700px;
`;

export const TextWrapper = styled("div")`
  border-radius: 3rem;
  max-width: 400px;
`;

export const BecomePatron = styled("a")`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  max-width: 510px;
  width: 100%;
  transition: transform 0.1s ease-in-out;
  text-decoration: none;

  &:hover,
  &:focus {
    transform: scale(1.05);
  }

  img {
    display: block;
    max-width: 100%;
    height: auto;
  }

  @media screen and (max-width: 769px) {
    width: auto;
  }
`;

